import { useState } from "react";
import "./style.css";

interface AnimatedCheckboxProps {
  value?: boolean;
  defaultValue?: boolean;
  disabled?: boolean;
  onChange?: (_: boolean) => void;
}

const AnimatedCheckbox: React.FC<AnimatedCheckboxProps> = ({
  value,
  defaultValue,
  disabled,
  onChange,
}) => {
  const [uncontrolledChecked, setUncontrolledChecked] = useState(defaultValue ?? false);
  const isChecked = value ?? uncontrolledChecked;
  const onCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.currentTarget.checked;
    if (value === undefined) setUncontrolledChecked(next);
    onChange?.(next);
  };
  return (
    <div className="center-checkbox">
      <label className="label-checkbox">
        <input
          type="checkbox"
          className="label__checkbox"
          checked={isChecked}
          onChange={onCheckboxChange}
          disabled={disabled}
        />
        <span className="label__text">
          <span className="label__check">
            <i className="fa fa-check icon"></i>
          </span>
        </span>
      </label>
    </div>
  );
};

export default AnimatedCheckbox;
